import React from "react";

export function IconFacebook() {
    return (
        <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5 40.3965C31.9362 40.3965 40.3965 31.9362 40.3965 21.5C40.3965 11.0638 31.9362 2.60352 21.5 2.60352C11.0638 2.60352 2.60352 11.0638 2.60352 21.5C2.60352 31.9362 11.0638 40.3965 21.5 40.3965Z" fill="#3B5999" />
            <path d="M26.9254 14.4537V11.0355C26.9254 11.0355 23.4316 11.002 23.1965 11.002C21.6176 11.002 19.35 12.7992 19.35 14.84V18.5018H16.0746V22.3818H19.2996V31.998H23.1209V22.3314H26.497L26.9254 18.5438H23.1629C23.1629 18.5438 23.1629 16.2174 23.1629 15.7639C23.1629 15.092 23.6668 14.4453 24.4226 14.4453C24.9265 14.4285 26.9254 14.4537 26.9254 14.4537V14.4537Z" fill="white" />
        </svg>

    );
}

export function IconLinked() {
    return (
        <svg width="43" height="43" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <path d="M22 41.3359C32.6789 41.3359 41.3359 32.6789 41.3359 22C41.3359 11.3211 32.6789 2.66406 22 2.66406C11.3211 2.66406 2.66406 11.3211 2.66406 22C2.66406 32.6789 11.3211 41.3359 22 41.3359Z" fill="#0077B5" />
            <path d="M11.3781 18.3734H16.5172V32.7422H11.3781V18.3734Z" fill="white" />
            <path d="M27.4227 18.3562C23.7531 18.3562 23.143 20.3672 23.143 20.3672V18.3734H19.1727V32.7422H23.1859C23.1859 32.7422 23.1859 25.6266 23.1859 24.4578C23.1859 23.2805 23.8649 21.7336 26.0305 21.7336C28.1875 21.7336 28.4453 23.8477 28.4281 24.1055C28.4024 24.3633 28.3852 32.7422 28.3852 32.7422H32.6219C32.6219 32.7422 32.6219 24.5695 32.6219 22.7734C32.6219 19.5336 30.4563 18.3562 27.4227 18.3562Z" fill="white" />
            <path d="M13.9562 16.3969C15.3754 16.3969 16.5258 15.2465 16.5258 13.8273C16.5258 12.4082 15.3754 11.2578 13.9562 11.2578C12.5371 11.2578 11.3867 12.4082 11.3867 13.8273C11.3867 15.2465 12.5371 16.3969 13.9562 16.3969Z" fill="white" />
        </svg>

    );
}

export function IconGithub() {
    return (
        <img src="./img/github.png" alt=""
            style={{ width: '39px', height: '39px', margin: 'auto', borderRadius: '50%' }} />
    );
}